import angular from 'angular';

import AttributesBuilderRow from './attributes-builder-row/attributes-builder-row';

const ComponentsModule = angular.module('control-room.poi.components.poi-edit.components', [AttributesBuilderRow.name]);

export default ComponentsModule;
